module.exports = __webpack_public_path__ + "img/Info.6479f4e3b.svg";